<template>
<vueper-slides class="no-shadow MySlider" :slide-ratio="props.slideRatio" lazy lazy-load-on-drag>
    <vueper-slide v-for="slide in slides"
        :key="slide_id(slide)"
        :image="slide_src(slide)"
        :title="slide_title(slide)"
        >
        <template #loader>
            <Loader class="loader" />
        </template>
    </vueper-slide>
</vueper-slides>
</template>

<style lang="scss" src="./MySlider.scss"></style>

<script setup>
import {computed} from 'vue'
import Loader from '@/comp/Loader/Loader.vue'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import {make_headPhotos} from '@/comp/photos.js'


const props = defineProps({
  slideRatio: Number, 
  slides: {
    type: Array,
    required: true,
  },
  srcKey: {
    type: String,
    default: 'src',
  },
  idKey: {
    type: String,
  },
  titleKey: {
    type: String,
  },
  convertCdn: {
    type: Boolean,
    default: false,
  }
})

const slides = computed(() => {
    let ret = props.slides
    if (props.convertCdn) {
        const useTitle = props.titleKey ? true : false
        ret = make_headPhotos( props.slides, null, {useTitle} )
    }
    return ret
})

const slide_src = slide => {
    return props.convertCdn ? slide[ 'src_next' ] : slide[ props.srcKey ]
}
const slide_id = slide => {
    let key = props.idKey ? props.idKey : props.srcKey
    return slide[ key ]
}
const slide_title = slide => {
    let ret = null
    if (props.titleKey) {
        ret = props.convertCdn ? slide['title'] :  slide[props.titleKey]
    }
    return ret
}


</script>    
